import { motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";

const links = [
    { label: "Work", hash: "#work" },
    { label: "Contact", hash: "#contact" },
];

export const Navigation = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const isHome = location.pathname === "/";

    const handleClick = (e, hash) => {
        e.preventDefault();
        if (isHome) {
            const el = document.querySelector(hash);
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
            navigate(`/${hash}`);
        }
    };

    const handleLogo = (e) => {
        e.preventDefault();
        if (isHome) {
            window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
            navigate("/");
        }
    };

    return (
        <motion.nav
            data-testid="site-navigation"
            initial={{ y: -40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="fixed top-0 inset-x-0 z-50 bg-cream/70 backdrop-blur-md"
        >
            <div className="max-w-[1500px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between ">
                <a
                    href="/"
                    onClick={handleLogo}
                    data-testid="nav-logo"
                    className="font-heading font-medium text-lg"
                >
                    Mona Saedi
                </a>
                <div className="flex items-center gap-1 md:gap-3">
                <div className="hidden sm:flex items-center md:gap-2">
                    {links.map((l) => (
                        <a
                            key={l.label}
                            href={`/${l.hash}`}
                            onClick={(e) => handleClick(e, l.hash)}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className="px-4 py-1.5 rounded-full text-sm font-body font-medium text-text-primary hover:bg-surface-1 transition-colors"
                        >
                            {l.label}
                        </a>
                    ))}
                </div>
                <a
                    href="mailto:mona.saedi90@gmail.com"
                    data-testid="nav-cta-email"
                    className="pill-btn ml-2 inline-flex items-center gap-1.5 rounded-full bg-[#2D2A26] text-cream px-5 py-2.5 text-sm font-body font-semibold"
                >
                    Say hi
                    <span aria-hidden>→</span>
                </a>
                </div>
            </div>
        </motion.nav>
    );
};

export default Navigation;
